import { useState, useRef, useEffect } from 'react'
import { FiMapPin, FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import './PopularDestinations.css'

// Static destination data by category with placeIds for deep linking
const DESTINATIONS = {
  beach: [
    { name: 'Cancun', location: 'Mexico', placeId: 'ChIJ21P2rgUrTI8Ris1fYjy3Ms4', image: 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?w=400&h=300&fit=crop' },
    { name: 'Miami', location: 'Florida', placeId: 'ChIJEcHIDqKw2YgRZU-t3XHylv8', image: 'https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=400&h=300&fit=crop' },
    { name: 'Phuket', location: 'Thailand', placeId: 'ChIJT1JixOIxUDARIbo9BoWayuk', image: 'https://images.unsplash.com/photo-1589394815804-964ed0be2eb5?w=400&h=300&fit=crop' },
    { name: 'Maldives', location: 'Indian Ocean', placeId: 'ChIJvXv7qr-ZtSQRiWKVgeEJRUE', image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=400&h=300&fit=crop' },
    { name: 'Bali', location: 'Indonesia', placeId: 'ChIJoQ8Q6NNB0S0RkOYkS7EPkSQ', image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=400&h=300&fit=crop' },
    { name: 'Santorini', location: 'Greece', placeId: 'ChIJ6bzjBc7NmRQR26Hvu5LB9Ak', image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?w=400&h=300&fit=crop' },
    { name: 'Turks and Caicos', location: 'Caribbean', placeId: 'ChIJdWu7vlVfS4kR3sGNAoDHEX4', image: 'https://images.unsplash.com/photo-1548574505-5e239809ee19?w=400&h=300&fit=crop' },
    { name: 'Maui', location: 'Hawaii', placeId: 'ChIJ3WFMzEorVXkRfz4R3EHnQ8w', image: 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=400&h=300&fit=crop' },
  ],
  ski: [
    { name: 'Aspen', location: 'Colorado', placeId: 'ChIJfTxB93w5QIcRcvYseNxCK8E', image: 'https://images.unsplash.com/photo-1605540436563-5bca919ae766?w=400&h=300&fit=crop' },
    { name: 'Whistler', location: 'Canada', placeId: 'ChIJh3uVA7I8h1QR9s_1dehBt0o', image: 'https://images.unsplash.com/photo-1544085311-11a028465b03?w=400&h=300&fit=crop' },
    { name: 'Chamonix', location: 'France', placeId: 'ChIJ5y7-LQZMiUcRgKO65CqrCAQ', image: 'https://images.unsplash.com/photo-1558380932-9f0ed72f08b9?w=400&h=300&fit=crop' },
    { name: 'Park City', location: 'Utah', placeId: 'ChIJ_QNjLGMPUocRlFc3Jd_Ecdg', image: 'https://images.unsplash.com/photo-1551524559-8af4e6624178?w=400&h=300&fit=crop' },
    { name: 'Zermatt', location: 'Switzerland', placeId: 'ChIJzeUuKaI1j0cRcG8ZQIj_AAQ', image: 'https://images.unsplash.com/photo-1708598660454-4011df6397f0?w=400&h=300&fit=crop' },
    { name: 'Banff', location: 'Canada', placeId: 'ChIJ_UoMkUXKcFMRY5Ss2r6ur8o', image: 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop' },
    { name: 'Lake Tahoe', location: 'California', placeId: 'ChIJUREfuaF4mYARILWv7q8fP4w', image: 'https://images.unsplash.com/photo-1645648381873-10328d077afe?w=400&h=300&fit=crop' },
    { name: 'Vail', location: 'Colorado', placeId: 'ChIJB89dUQFwaocRxKOafh_AzMk', image: 'https://images.unsplash.com/photo-1600477315512-9c8bffa16e51?w=400&h=300&fit=crop' },
  ],
  cityBreaks: [
    { name: 'New York City', location: 'USA', placeId: 'ChIJOwg_06VPwokRYv534QaPC8g', image: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop' },
    { name: 'London', location: 'United Kingdom', placeId: 'ChIJdd4hrwug2EcRmSrV3Vo6llI', image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&h=300&fit=crop' },
    { name: 'Paris', location: 'France', placeId: 'ChIJD7fiBh9u5kcRYJSMaMOCCwQ', image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&h=300&fit=crop' },
    { name: 'Tokyo', location: 'Japan', placeId: 'ChIJ51cu8IcbXWARiRtXIothAS4', image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=400&h=300&fit=crop' },
    { name: 'Barcelona', location: 'Spain', placeId: 'ChIJ5TCOcRaYpBIRCmZHTz37sEQ', image: 'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=400&h=300&fit=crop' },
    { name: 'Dubai', location: 'UAE', placeId: 'ChIJRcbZaklDXz4RYlEphFBu5r0', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&h=300&fit=crop' },
    { name: 'Amsterdam', location: 'Netherlands', placeId: 'ChIJVXealLU_xkcRja_At0z9AGY', image: 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=400&h=300&fit=crop' },
    { name: 'Rome', location: 'Italy', placeId: 'ChIJu46S-ZZhLxMROG5lkwZ3D7k', image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=400&h=300&fit=crop' },
  ],
  allInclusive: [
    { name: 'Cancun', location: 'Mexico', placeId: 'ChIJ21P2rgUrTI8Ris1fYjy3Ms4', image: 'https://images.unsplash.com/photo-1552074284-5e88ef1aef18?w=400&h=300&fit=crop' },
    { name: 'Punta Cana', location: 'Dominican Republic', placeId: 'ChIJd_7LXWSRqI4R8_YS7fociGE', image: 'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?w=400&h=300&fit=crop' },
    { name: 'Montego Bay', location: 'Jamaica', placeId: 'ChIJseJ3_V0q2o4RZlfMWtua1vw', image: 'https://images.unsplash.com/photo-1542356670-bdf906b3ac87?w=400&h=300&fit=crop' },
    { name: 'Riviera Maya', location: 'Mexico', placeId: 'ChIJ4zZLJnZNTo8RYL2yX-Vgtn0', image: 'https://images.unsplash.com/photo-1581710862235-eb6e05d8783f?w=400&h=300&fit=crop' },
    { name: 'Aruba', location: 'Caribbean', placeId: 'ChIJ23da4s84hY4RL4yBiT6KavE', image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=400&h=300&fit=crop' },
    { name: 'Los Cabos', location: 'Mexico', placeId: 'ChIJoQjlifNKr4YRaLiiwWLfpEs', image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&h=300&fit=crop' },
    { name: 'Playa del Carmen', location: 'Mexico', placeId: 'ChIJYU4t0iNDTo8R3EqrO3gLweg', image: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=400&h=300&fit=crop' },
    { name: 'Barbados', location: 'Caribbean', placeId: 'ChIJoxoyrvvxQ4wRKzb0jLNR7A4', image: 'https://images.unsplash.com/photo-1633847016580-b7a15cc813d7?w=400&h=300&fit=crop' },
  ],
  adventure: [
    { name: 'Costa Rica', location: 'Central America', placeId: 'ChIJJcmsIWLlko8RK5qBNSX3VGI', image: 'https://images.unsplash.com/photo-1582218290380-ae58573670e3?w=400&h=300&fit=crop' },
    { name: 'Iceland', location: 'Nordic', placeId: 'ChIJQ2Dro1Ir0kgRmkXB5TQEim8', image: 'https://images.unsplash.com/photo-1520769669658-f07657f5a307?w=400&h=300&fit=crop' },
    { name: 'Queenstown', location: 'New Zealand', placeId: 'ChIJX96o1_Ed1akRAKZ5hIbvAAU', image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?w=400&h=300&fit=crop' },
    { name: 'Patagonia', location: 'Chile', placeId: 'ChIJHx8GGWZx9b0RWXYJhzuqEjU', image: 'https://images.unsplash.com/photo-1531761535209-180857e963b9?w=400&h=300&fit=crop' },
    { name: 'Bali', location: 'Indonesia', placeId: 'ChIJoQ8Q6NNB0S0RkOYkS7EPkSQ', image: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?w=400&h=300&fit=crop' },
    { name: 'Peru', location: 'Machu Picchu', placeId: 'ChIJMYRZJtjVbZERXTEYI8yWqSo', image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=400&h=300&fit=crop' },
    { name: 'Moab', location: 'Utah', placeId: 'ChIJjS24muXhR4cRLcTV8XqxMgs', image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=300&fit=crop' },
    { name: 'Interlaken', location: 'Switzerland', placeId: 'ChIJBRqSMWqZUxQRAL4CTPEaEZw', image: 'https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?w=400&h=300&fit=crop' },
  ],
}

const CATEGORIES = [
  { key: 'beach', name: 'Beach' },
  { key: 'ski', name: 'Ski' },
  { key: 'cityBreaks', name: 'City breaks' },
  { key: 'allInclusive', name: 'All-inclusive' },
  { key: 'adventure', name: 'Adventure' },
]

function PopularDestinations() {
  const [activeCategory, setActiveCategory] = useState('beach')
  const carouselRef = useRef(null)
  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(true)

  // Drag state
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollStart = useRef(0)
  const didDrag = useRef(false)

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft = 0
      checkScrollButtons()
    }
  }, [activeCategory])

  const checkScrollButtons = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current
      setCanScrollLeft(scrollLeft > 5)
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 5)
    }
  }

  useEffect(() => {
    checkScrollButtons()
    const carousel = carouselRef.current
    if (carousel) {
      carousel.addEventListener('scroll', checkScrollButtons)
      window.addEventListener('resize', checkScrollButtons)
      return () => {
        carousel.removeEventListener('scroll', checkScrollButtons)
        window.removeEventListener('resize', checkScrollButtons)
      }
    }
  }, [])

  const scroll = (direction) => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.querySelector('.destination-card')?.offsetWidth || 280
      const gap = 16
      const scrollAmount = (cardWidth + gap) * 2
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      })
    }
  }

  // Drag-to-scroll handlers (matching RegionalDeals pattern)
  const handleMouseDown = (e) => {
    isDragging.current = true
    didDrag.current = false
    startX.current = e.pageX
    scrollStart.current = carouselRef.current?.scrollLeft || 0
    if (carouselRef.current) {
      carouselRef.current.style.scrollSnapType = 'none'
      carouselRef.current.style.scrollBehavior = 'auto'
    }
  }

  const handleMouseMove = (e) => {
    if (!isDragging.current || !carouselRef.current) return
    const dx = e.pageX - startX.current
    if (Math.abs(dx) > 5) {
      didDrag.current = true
      carouselRef.current.scrollLeft = scrollStart.current - dx
    }
  }

  const handleMouseUp = () => {
    isDragging.current = false
    if (carouselRef.current) {
      carouselRef.current.style.scrollSnapType = 'x mandatory'
      carouselRef.current.style.scrollBehavior = ''
    }
  }

  const handleClick = (e) => {
    if (didDrag.current) {
      e.preventDefault()
      didDrag.current = false
    }
  }

  // Build deep link URL for a destination
  const buildDestinationLink = (destination) => {
    // Calculate upcoming weekend (Friday to Sunday)
    const today = new Date()
    const dayOfWeek = today.getDay() // 0=Sun, 1=Mon, ..., 6=Sat
    const daysUntilFriday = (5 - dayOfWeek + 7) % 7 || 7 // If today is Friday, go to next Friday
    const friday = new Date(today)
    friday.setDate(today.getDate() + daysUntilFriday)
    const sunday = new Date(friday)
    sunday.setDate(friday.getDate() + 2)
    
    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    
    const checkin = formatDate(friday)
    const checkout = formatDate(sunday)
    
    // Build deep link URL matching the app's format
    const params = new URLSearchParams({
      placeId: destination.placeId,
      placeTypes: 'geocode',
      name: `${destination.name}, ${destination.location}`,
      checkin,
      checkout,
      rooms: '1',
      adults: '2',
      sorting: '1',
      language: 'en',
      currency: 'USD'
    })
    
    return `/hotels?${params.toString()}`
  }

  const currentDestinations = DESTINATIONS[activeCategory] || []

  return (
    <section className="popular-destinations">
      <div className="container">
        <div className="popular-destinations-header">
          <h2>Popular destinations</h2>
          <p className="header-subtitle">Explore trending places to stay</p>
        </div>

        {/* Category Tabs */}
        <div className="category-tabs-wrapper">
          <div className="category-tabs">
            {CATEGORIES.map(category => (
              <button
                key={category.key}
                className={`category-tab ${activeCategory === category.key ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.key)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Carousel */}
        <div className="destinations-carousel-container">
          {canScrollLeft && (
            <button
              className="carousel-arrow carousel-arrow-left"
              onClick={() => scroll('left')}
              aria-label="Scroll left"
            >
              <FiChevronLeft size={24} />
            </button>
          )}

          <div
            ref={carouselRef}
            className="destinations-carousel-track"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            {currentDestinations.map((destination, index) => (
              <a
                key={`${activeCategory}-${index}`}
                href={buildDestinationLink(destination)}
                className="destination-card"
                onClick={handleClick}
                draggable={false}
              >
                <div className="destination-image">
                  <img
                    src={destination.image}
                    alt={destination.name}
                    loading="lazy"
                    draggable={false}
                    width="238"
                    height="179"
                  />
                </div>
                <div className="destination-info">
                  <h3>{destination.name}</h3>
                  <p className="destination-location">
                    <FiMapPin size={14} />
                    {destination.location}
                  </p>
                </div>
              </a>
            ))}
          </div>

          {canScrollRight && (
            <button
              className="carousel-arrow carousel-arrow-right"
              onClick={() => scroll('right')}
              aria-label="Scroll right"
            >
              <FiChevronRight size={24} />
            </button>
          )}
        </div>
      </div>
    </section>
  )
}

export default PopularDestinations
